(()=>{
  const q=(s,r=document)=>r.querySelector(s);
  const qa=(s,r=document)=>Array.from(r.querySelectorAll(s));

  function initReveal(root){
    qa('[data-ct69-reveal]',root).forEach((el,i)=>{el.style.transitionDelay=Math.min(i%6,5)*45+'ms'});
    if('IntersectionObserver' in window){
      const io=new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target)}
      }),{threshold:.08,rootMargin:'0px 0px -5% 0px'});
      qa('[data-ct69-reveal]',root).forEach(el=>io.observe(el));
    }else qa('[data-ct69-reveal]',root).forEach(el=>el.classList.add('is-visible'));
  }

  function initAnchors(root){
    qa('a[href^="#ct69-"]',root).forEach(a=>a.addEventListener('click',event=>{
      const target=q(a.getAttribute('href'));
      if(!target)return;
      event.preventDefault();
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      history.replaceState(null,'',a.getAttribute('href'));
    }));
  }


  function initQuickGuide(root){
    const items=qa('details',root);
    items.forEach(item=>item.addEventListener('toggle',()=>{
      if(!item.open)return;
      items.forEach(other=>{if(other!==item)other.open=false});
    }));
  }


  function init(){
    qa('[data-ct69-root],.ct69-more').forEach(root=>{initReveal(root);initAnchors(root)});
    qa('[data-ct70-guide]').forEach(initQuickGuide);
  }

  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
})();
